// ========================================
// 组件映射配置
// 用于菜单管理中动态加载组件
// ========================================

// 组件选项（用于下拉选择）
export const componentOptions = [
  {
    label: '布局组件',
    options: [
      { label: 'Layout布局', value: 'layout' }
    ]
  },
  {
    label: '作业中心',
    options: [
      { label: '我的任务', value: 'operator/Tasks' },
      { label: '我的客户', value: 'operator/Clients' },
      { label: '客户详情页', value: 'operator/CustomerDetail' },
      { label: '日程日历', value: 'operator/Calendar' },
      { label: '业绩统计', value: 'operator/Data' }
    ]
  },
  {
    label: '管理中心',
    options: [
      { label: '订单管理', value: 'admin/Orders' },
      { label: '历史订单', value: 'admin/OrderHistory' },
      { label: '客户管理', value: 'admin/Customers' },
      { label: '客户详情页', value: 'admin/CustomerDetail' },
      { label: '人员管理', value: 'admin/Users' },
      { label: '审批中心', value: 'admin/Approvals' }
    ]
  },
  {
    label: '财务核算',
    options: [
      { label: '运营分析', value: 'admin/Analysis' },
      { label: '交付人核算', value: 'admin/AdminAccounting' },
      { label: '组长核算', value: 'admin/LeaderAccounting' },
      { label: '通知中心', value: 'admin/Notifications' }
    ]
  },
  {
    label: '系统配置',
    options: [
      { label: '角色管理', value: 'admin/Roles' },
      { label: '权限管理', value: 'admin/Permissions' },
      { label: '菜单管理', value: 'admin/MenuManagement' },
      { label: '系统设置', value: 'admin/Settings' },
      { label: '数据备份', value: 'admin/Backups' },
      { label: '监控管理', value: 'admin/MonitorDashboard' }
    ]
  },
  {
    label: '公共页面',
    options: [
      { label: '首页', value: 'common/Home' },
      { label: '登录页', value: 'common/Login' },
      { label: '404页面', value: 'common/NotFound' }
    ]
  }
]

// 组件加载映射（用于动态导入）
export const componentMap = {
  // 布局
  'layout': () => import('@/views/common/Layout.vue'),
  
  // 作业中心（任务大厅已下线，组件保留在 menus 表中可恢复）
  'operator/Tasks': () => import('@/views/operator/Tasks.vue'),
  'operator/Clients': () => import('@/views/operator/Clients.vue'),
  'operator/CustomerDetail': () => import('@/views/operator/CustomerDetail.vue'),
  'operator/Calendar': () => import('@/views/operator/Calendar.vue'),
  'operator/Data': () => import('@/views/operator/Data.vue'),
  
  // 管理中心
  'admin/Orders': () => import('@/views/admin/Orders.vue'),
  'admin/OrderHistory': () => import('@/views/admin/OrderHistory.vue'),
  'admin/Customers': () => import('@/views/admin/Customers.vue'),
  'admin/CustomerDetail': () => import('@/views/admin/CustomerDetail.vue'),
  'admin/Users': () => import('@/views/admin/Users.vue'),
  'admin/Approvals': () => import('@/views/admin/Approvals.vue'),
  
  // 财务核算
  'admin/Analysis': () => import('@/views/admin/Analysis.vue'),
  'admin/AdminAccounting': () => import('@/views/admin/AdminAccounting.vue'),
  'admin/LeaderAccounting': () => import('@/views/admin/LeaderAccounting.vue'),
  'admin/Notifications': () => import('@/views/admin/Notifications.vue'),
  
  // 系统配置
  'admin/Roles': () => import('@/views/admin/Roles.vue'),
  'admin/Permissions': () => import('@/views/admin/Permissions.vue'),
  'admin/MenuManagement': () => import('@/views/admin/MenuManagement.vue'),
  'admin/Settings': () => import('@/views/admin/Settings.vue'),
  'admin/Backups': () => import('@/views/admin/Backups.vue'),
  'admin/MonitorDashboard': () => import('@/views/admin/MonitorDashboard.vue'),
  
  // 公共页面
  'common/Home': () => import('@/views/common/Home.vue'),
  'common/Login': () => import('@/views/common/Login.vue'),
  'common/NotFound': () => import('@/views/common/NotFound.vue')
}

// 安全加载组件
export function loadComponent(componentName) {
  if (!componentName || componentName === 'layout') {
    return componentMap['layout']
  }
  
  if (componentMap[componentName]) {
    return componentMap[componentName]
  }
  
  console.warn(`组件 ${componentName} 未在映射表中注册，尝试动态加载`)
  
  // 尝试动态加载（安全模式）
  try {
    return () => import(`@/views/${componentName}.vue`)
  } catch (error) {
    console.error(`加载组件 ${componentName} 失败:`, error)
    return () => import('@/views/common/NotFound.vue')
  }
}

// 验证组件是否存在
export function isComponentExist(componentName) {
  return !!componentMap[componentName]
}